// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__msKGL","truncatedText":"styles_truncatedText__X1R9E","fullText":"styles_fullText__rlM19","textContainer":"styles_textContainer__H5RXh"};